<template>
  <div class="examination">
    <div class="title" style="po">
      <span :class="{'curspan':suoyin1==index}" v-for="(mrec,index) in mrec_title" :key="index" @click="changeTab(index)">{{mrec}}</span>
      <!-- <img src="../assets/stop_j.png" class="stop_j" alt="">
      <img src="../assets/stop_x.png" class="stop_x" alt="">
      <select name="" id="" style="padding:3px 15px;">
        <option value="全部年份" v-for="">全部年份</option>
        <option value="2019">2019年</option>
        <option value="2020">2020年</option>
      </select> -->
    </div>
    <!-- <div class="content">
      <div class="nav">
        <span class="spn1">试卷名称</span>
        <span class="spn2">考试时间</span>
        <span class="spn3">分数</span>
        <span class="spn4">总分数</span>
        <span class="spn5">状态</span>
        <span class="spn6">操作</span>

        //需要的
         <span class="spn1">课程类型</span>
        <span class="spn2">课程名称</span>
        <span class="spn3">试卷名称</span>
        <span class="spn4">成绩</span>
        <span class="spn5">状态</span>
        <span class="spn6">考试期限</span>
        <span class="spn6">查看详情</span>
      </div> -->
    <!-- <ul>
        <li v-for="(item,index) in data" :key="index">
            <span >{{item.type==1?"专业课":"公需课"}}</span>
            <span >{{item.kecheng_title}}</span>
            <span >{{item.shijuan_info.title}}</span>
            <span >{{item.score}}</span>
            <span class="spn5 active1"  v-if="item.is_pass=='0'">{{item.is_pass=='0'?'尚未通过':'考试通过'}}</span>
            <span class="spn5  active" v-else>{{item.is_pass=='0'?'尚未通过':'考试通过'}}</span>
            <span>{{item.time}}</span>
            <span   @click="todetail(item.id,item.shijuan_title)">查看详情</span>
        </li>
      </ul> -->
    <div>
      <div class="kuang">
        <p><span>留言板</span><span @click="tijiao(id=1)">留言</span></p>
        <input class="input" type="text" v-model="content_s">
      </div>
    </div>
    <div class="wenda" v-for="(item,index) in getwenda" :key='index'>
      <p>
        <img src="../assets/wen.png" alt=""><span>{{item.content}}</span><span @click="delet(item.id)">删除</span>
      </p>
      <div class="clearfix"></div>
      <p>
          <span>提问时间：</span><span>{{item.create_time}} </span>
      </p>
      <div class="da" v-for="(items,index) in item.sublist" :key='index'>
        <img src="../assets/da.png" alt="">
        <div >
          {{items.content}}
        </div>
        <div class="clearfix"></div>
        <p> 
          <span>回复时间：</span><span>{{items.create_time}}</span>
        </p>
      </div>
      <div class="wen_two" v-if="item.sublist.length!=0">
          <input class="input" type="text" v-model="content_z">
          
          <p><span @click="tijiao(id=2,item.sublist[item.sublist.length-1].id)">追问</span></p>
      </div>
      <div v-else></div>
    </div>
    <div class="nodata" v-show="nodata">
    </div>
    <div class="block" style="text-align:center;margin-top:10px;">
      <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo" :page-size="13"
        layout="total,prev, pager, next, jumper" :total="count" :pager-count="7" v-show="count>13">
      </el-pagination>
    </div>
  </div>
 
</template>

<script>
  import qs from 'qs'
  export default {
    name: "examination",
    data() {
      return {
        nodata: true,
        uid: "",
        token: "",
        page: 1,
        num: 13,
        data: [],
        
        pageNo: 1,
        currentPage: 1, //当前页数 ，默认为1
        currentPageData: [], //当前页显示内容
        pageSize: 1,
        fenye: true,
        count: 0,
        pagevalue: false,
        mrec_title: ['互动问答'],
        suoyin1: 0,
        content_s:"",
        getwenda:"",
        content_z:""
      }
    },
    watch: {
      token: {
        handler: function(val) {
          if (val) {
            // this.getdata ()
          } else {
            this.removeInfo()
          }
        }
      },
      deep: true
    },
    created() {
      var that = this;
      this.uid = localStorage.getItem("uid");
      this.token = localStorage.getItem("token");
      var date = new Date();
      this.year = date.getFullYear();
      if (this.token) {
        if (sessionStorage.getItem('suoyin1') == 0) {
          this.suoyin1 = sessionStorage.getItem('suoyin1');
        } else if (sessionStorage.getItem('suoyin1') == 1) {
          this.suoyin1 = sessionStorage.getItem('suoyin1');
        }
      }
      var that = this
      var date = new Date;
      this.year = date.getFullYear()
      this.uid = localStorage.getItem('uid')
      this.token = localStorage.getItem('token')
      if (this.token) {
      } else {
        this.removeInfo()
      }
    },
    mounted() {
       this.wenda()
    },
    methods: {
      //获取问答列表
      wenda(){
        var obj = {
          uid: this.uid,
          token: this.token,
          page:this.page,
          num:this.num
        }
        var that = this
      this.$axios.post('/wenda/get_my_wenda',qs.stringify(obj)).then(res=>{
        var data =  res.data.data.data
        var wentime = Object.keys(data)
        var array = []
        for(var key in data){
          array.push(data[key]);
        }
        this.getwenda = array
        console.log(that.getwenda)
        for(var i=0;i<array.length;i++){
            var date = new Date();
            var year = date.getFullYear(array[i].create_time);
            var month = date.getMonth(array[i].create_time) + 1;
            var day = date.getDate(array[i].create_time);
            if (month < 10) {
                month = "0" + month;
            }
            if (day < 10) {
                day = "0" + day;
            }
            var nowDate = year + "-" + month + "-" + day;
            that.getwenda[i].create_time = nowDate
            this.sublist_length = that.getwenda[i].sublist.length
            console.log(this.sublist_length)
            for(var j=0;j<that.getwenda[i].sublist.length;j++){
              var date = new Date();
              var year = date.getFullYear(that.getwenda[i].sublist[j].create_time);
              var month = date.getMonth(that.getwenda[i].sublist[j].create_time) + 1;
              var day = date.getDate(that.getwenda[i].sublist[j].create_time);
              if (month < 10) {
                  month = "0" + month;
              }
              if (day < 10) {
                  day = "0" + day;
              }
              var nowDate = year + "-" + month + "-" + day;
              that.getwenda[i].sublist[j].create_time = nowDate
              console.log(that.getwenda[i].sublist[j].create_time)
              }
        }
        
      })
      },
      //提交问答

      tijiao(id,items_id){
        console.log(id,items_id)
        var that = this
        var content = document.getElementById('color')
        if(id==1){
            var obj = {
              uid: this.uid,
              token: this.token,
              content:this.content_s,
              id:'0'
            }
        }else if(id==2){
          var obj = {
            uid: this.uid,
            token: this.token,
            content:this.content_z,
            id:items_id
          }
        }
        this.$axios.post('/wenda/add_wenda',qs.stringify(obj)).then(res=>{
          if(res.data.status == 'error'){
            that.$message.error({
              message: res.data.errormsg,
              duration: 1600
            });
          }else{
            this.wenda()
            this.content_s = ''
          }
        })
      },
      //删除问答
      delet(id){
        console.log(id)
        var that = this
        var obj = {
          uid: this.uid,
          token: this.token,
          id:id
        }
        this.$axios.post('/wenda/del_wenda',qs.stringify(obj)).then(res=>{
          console.log(res)
          if(res.data.status == 'error'){
            that.$message.error({
              message: res.data.errormsg,
              duration: 1600
            });
          }else{
            this.wenda()
          }
        })
      },
      changeTab: function(index) {
        this.suoyin1 = index;
        sessionStorage.setItem('suoyin1', this.suoyin1)
        if (index == 0) {
          this.kemuid = "";
          this.page = 1;
          this.kaoshi();
        } else if (index == 1) {
          this.kemuid = 1;
          this.page = 1;
          this.kaoshi_z();
        } else if (index == 2) {
          this.kemuid = 2;
          this.page = 1;
          this.kaoshi_g();
        }
      },
      //分页
      handleCurrentChange(val) {
        this.page = val
        //console.log(`当前页: ${val}`);
        localStorage.setItem('pagenum', this.page)
        this.kaoshi()
      },
      removeInfo() {
        var that = this
        this.$message.error({
          message: "重新登录",
          duration: 1600
        });
        localStorage.removeItem("uid");
        localStorage.removeItem("token");
        localStorage.removeItem("sex");
        localStorage.removeItem("name");
        localStorage.removeItem("mobile");
        localStorage.removeItem("id_card");
        setTimeout(() => {
          that.$router.push({
            path: '/'
          });
        }, 1600);
      },
      //获取考试记录
      kaoshi_z() {
        //获取考试记录
        var that = this;
        var data = {
          page: this.page,
          uid: this.uid,
          token: this.token,
          num: this.num,
          type: '1'
        };
        this.$axios({
          method: "post",
          url:  "/kaoshi/get_kaoshi_log",
          data: qs.stringify(data)
        }).then(res => {
          //console.log(res);
          if (res.data.status == "ok") {
            that.data = [];
            that.data = res.data.data.data;
            //that.count = Number(res.data.data.count);
            that.pageSize = res.data.data.pageSize;
            // that.kecheng_title=res.data.data.shijuan_title
            if (res.data.data.data.length == 0) {
              that.nodata = true;
              that.fenye = false;
            } else {
              that.nodata = false;
              that.fenye = true;
            }
          } else if (res.data.status == "relogin") {
            that.removeInfo();
          } else {
            that.$message.error({
              message: res.data.errormsg,
              duration: 1600
            });
          }
        });
      },
      kaoshi_g() {
        //获取考试记录
        var that = this;
        var data = {
          page: this.page,
          uid: this.uid,
          token: this.token,
          num: this.num,
          type: '2'
        };
        this.$axios({
          method: "post",
          url:  "/kaoshi/get_kaoshi_log",
          data: qs.stringify(data)
        }).then(res => {
          //console.log(res);
          if (res.data.status == "ok") {
            that.data = [];
            that.data = res.data.data.data;
            that.count = Number(res.data.data.count);
            that.pageSize = res.data.data.pageSize;
            // that.kecheng_title=res.data.data.shijuan_title
            if (res.data.data.data.length == 0) {
              that.nodata = true;
              that.fenye = false;
            } else {
              that.nodata = false;
              that.fenye = true;
            }
          } else if (res.data.status == "relogin") {
            that.removeInfo();
          } else {
            that.$message.error({
              message: res.data.errormsg,
              duration: 1600
            });
          }
        });
      },
      kaoshi() {
        //获取考试记录
        var that = this;
        var data = {
          page: this.page,
          uid: this.uid,
          token: this.token,
          num: this.num
        };
        this.$axios({
          method: "post",
          url:  "/kaoshi/get_kaoshi_log",
          data: qs.stringify(data)
        }).then(res => {
          //console.log(res);
          if (res.data.status == "ok") {
            that.data = [];
            that.data = res.data.data.data;
            that.count = Number(res.data.data.count);
            that.pageSize = res.data.data.pageSize;
            // that.kecheng_title=res.data.data.shijuan_title
            if (res.data.data.data.length == 0) {
              that.nodata = true;
              that.fenye = false;
            } else {
              that.nodata = false;
              that.fenye = true;
            }
          } else if (res.data.status == "relogin") {
            that.removeInfo();
          } else {
            that.$message.error({
              message: res.data.errormsg,
              duration: 1600
            });
          }
        });
      },
      //查看详情
      todetail(num, tit) {
        this.$router.push({
          path: "/submit",
          query: {
            kaoshi_id: num,
            // kecheng_title:tit,
          }
        });
      },
      //去学习
      gostady(e, num) {
        var that = this
        //console.log(e,num)
        if (e.target.innerHTML == "继续学习") {
          that.$emit('more', 'allCourses')
        }
        if (e.target.innerHTML == "去考试") {
          that.$router.push({
            path: '/kaoshi',
            query: {
              shijuan_id: num
            }
          })
        }
      },
      //切换分页
      current_change(currentPage) {
        this.currentPage = currentPage
        //console.log(currentPage)
      }

    }
  };
</script>

<style lang="less" scoped>
  .examination {
    width: 948px;
    background-color: #fff;
    padding: 0 20px;
    min-height: 600px;
    box-sizing: border-box;

    .title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #f4f4f4;
      margin-bottom: 20px;
      box-sizing: border-box;
      position: relative;

      .stop_j {
        position: absolute;
        right: 18px;
        top: 21px;
      }

      .stop_x {
        position: absolute;
        right: 18px;
        top: 28px;
      }

      h3 {
        color: #ad0008;

        span {
          padding-bottom: 13px;
          border-bottom: 2px solid #ad0008;
          box-sizing: border-box;
          cursor: default;
        }
      }

      select {
        float: right;
        margin: 15px;
      }

      select,
      option {
        color: #f00;
      }
    }

    .content {
      width: 100%;
      height: 640px;

      .nav {
        height: 40px;
        line-height: 40px;
        background-color: #e1f1ff;
        color: #1a1a1c;
        font-size: 0;
        text-align: center;
        display: flex;

        span {
          flex: 1;
          font-size: 14px;
          width: 12%;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: default;

          &.spn1 {
            width: 20%;
          }

          &.spn2 {
            width: 20%;
          }

          //  &.spn4,&.spn5,&.spn6{
          //     width: 7%;
          // }
        }
      }

      ul {
        li {
          height: 40px;
          line-height: 40px;
          color: #1a1a1c;
          font-size: 0;
          text-align: center;
          display: flex;

          span {
            font-size: 14px;
            flex: 1;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: default;

            //  border:1px solid red;
            &.spn2 {
              width: 20%;
            }

            &.spn1 {
              width: 20%;
            }

            &.spn6 {
              cursor: pointer;
            }

            &.active {
              color: #66d668;
            }

            &.active1 {
              color: #ff6767;
            }

            &.active2 {
              color: #006acc;
            }

          }

          &:nth-child(2n) {
            background-color: #f4f4f4;
          }
        }
      }

      .nodata {
        width: 212px;
        height: 240px;
        margin: 80px auto;
        background-image: url('../assets/nodata.png');
      }

    }
  }

  .title {
    width: 100%;
    height: 55px;
    // margin-bottom: 20px;
    font-size: 18px;
    padding-left: 20px;
    line-height: 55px;
    color: #ad0008;
    box-sizing: border-box;
    border-bottom: 2px solid #eee;

    span {
      margin-right: 20px;
      cursor: pointer;
      color: #ad0008;
    }

    .curspan {
      border-bottom: 2px solid #ad0008;
      padding-bottom: 13px;
      color: #ad0008;
    }
  }

  .kuang {
    width: 866px;
    min-height: 153px;
    margin: 0 auto;
    padding-bottom: 7px;
    background: #e3e3e3;
    margin-bottom: 13px;
    p {
      font-size: 16px;
      padding: 20px 20px 0;
      span {
        color: #ad0008;
      }

      span:nth-child(2) {
        float: right;
        font-size: 14px;
        background: #ad0008;
        color: #fff;
        letter-spacing: 10px;
        padding: 7px 20px;
      }
    }

    .input {
      display: block;
      width: 819px;
      min-height: 95px;
      border: 1px #d5d5d5 solid;
      background: #fff;
      margin: 20px auto;
      padding:10px;
    }
  }
  .wenda{
    width: 866px;
    margin: 30px auto;
    border-bottom:1px #eee solid;
    padding-bottom:30px;
    p:nth-child(1){
      margin-top: 33px;
      height: 39px;
      padding:0 40px;
      line-height: 39px;
      color: #f89015;
      img{
        height: 39px;
        width:39px;
        margin-right: 16px;
        float: left;
      }
      span:nth-child(2){
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        width: 650px;
        display: block;
        height: 39px;
        line-height: 39px;
        float: left;

      }
      span:nth-child(3){
        float: right;
        background: #f89015;
        height: 26px;
        display: block;
        width: 66px;
        color: #fff;
        line-height: 26px;
        text-align: center;
      }
    }
    p:nth-child(3){
      color: #bbbbbb;
      padding: 0 95px;
    }
    .da{
      padding: 0 0 0 95px;
      margin-top: 29px;
      img{
        margin-right: 16px;
        float: left;
      }
      div:nth-child(2){
        float: left;
        width: 677px;
        line-height: 32px;
        min-height: 32px;
      }
      p{
        color:#bbbbbb;
        width: 677px;
        margin-left:48px;
      }
    }
  }
  .wen_two{
    min-height:115px;
    border:1px #c1c1c1 solid;
    width:700px;
    margin:20px auto 0;
    background:#e3e3e3;
    text-align:center;
    input{
      min-height:50px;
      border:1px #ccc solid;
      width:660px;
      margin:15px auto;
      padding:0 10px;
    }
    p{
      text-align:right;
      span{
        margin-right:20px;
        padding:3px 10px;
        background:#ad0008;
        color:#fff;
        font-size:12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/examrecord.vue